<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="dialogForm"
    :title="title"
    :visible.sync="dialogVisible"
    width="850px"
    :before-close="handleClose"
  >
    <div class="line"></div>
    <div class="video">
      <div class="videoLeft">
        <h1>
          {{ numberPlate }}
          <span style="margin-left: 4px">{{ date }}{{ regionTow }}</span>
        </h1>
        <ul class="videoList">
          <li
            v-for="(item, index) in playList"
            :key="index"
            @click="loadReplay(item)"
            @mouseover="mouseover(item, index)"
            :class="item.active ? 'active' : ''"
            @mouseout="mouseout(item)"
          >
            <i
              class="iconfont iconshipin"
              :style="item.isCheck ? 'opacity: 1!important;' : ''"
            ></i>
            <p :style="item.isCheck ? 'color: #000;!important;' : ''">
              {{ dateFormat(item.startTime) }}
            </p>
            <p :style="item.isCheck ? 'color: #000;!important;' : ''">
              {{ timeFormat(item.startTime) }}
              <span>~</span>
              {{ timeFormat(item.endTime) }}
            </p>
            <p :style="item.isCheck ? 'color: #000;!important;' : ''">
              {{ channelHandle(item.channel) }}
            </p>
          </li>
        </ul>
      </div>
      <div class="videoRight" v-loading="fullscreenLoading">
        <!-- github地址: https://github.com/langyuxiansheng/vue-aliplayer-v2 -->
        <img
          src="../../../static/img/replay.png"
          v-if="!realPlayShow"
          width="70%"
          style="margin-top: 10%"
        />
        <!-- <vue-aliplayer-v2
          :options="options"
          class="aliplayer"
          v-if="realPlayShow"
        /> -->
        <hlsVideo
        class="aliplayer"
          v-if="realPlayShow"
          ref="videoPlay"
          :videoUrl="flvVideoUrl"
        ></hlsVideo>
      </div>
    </div>
  </el-dialog>
</template>

<script>
// import hlsVideo from "@/components/vueAliplayerV2/videoPlayer";
export default {
  // components:{
  //   hlsVideo,
  // },
  name: "rePlay",
  data() {
    return {
      flvVideoUrl:'',
      videoShow: true,
      videoPlayer: null,
      realPlayShow: false,
      fullscreenLoading: false, // 加载中
      startAndEndTime: "",
      dialogVisible: true,
      options: {
        source: "",
        isLive: true, //是否直播
        useH5Prism: true, //h5播放器
        disableSeek: true, //是否禁用进度条的Seek
      },
      title: "历史回放",
      autoplay: false,
      playList: [], //播放列表
      numberPlate: "",
      date: "",
      videoDetail: [],
      deviceTel: "",
      regionTow: 0,
      time: null,
      loading: null,
    };
  },
  mounted() {},
  destroyed() {
    if (this.videoPlayer) {
      this.videoPlayer.dispose();
    }
  },
  methods: {
    channelHandle(e) {
      return this.videoDetail[e - 1];
    },
    setData(e,item) {
      this.numberPlate = e.numberPlate;
      this.date = e.date;
      this.videoDetail = e.videoDetail.split("&&");
      this.deviceTel = e.deviceTel;
      this.regionTow = e.regionTow;
      this.getVideoList(item);
    },
    dateFormat(val) {
      return val.substring(6, 10);
    },
    timeFormat(val) {
      return val.substring(11, 19);
    },
    handleClose(done) {
      this.$parent.rePlayShow = false;
      done();
    },
    //获取视频列表
    getVideoList(item) {
      let that = this;
      this.fullscreenLoading = true;
      // var date = this.$util.dateFormat("YYYY-mm-dd", new Date());
      var date = this.date
      var startTime = "";
      var endTime = "";
      if (this.regionTow == "上午") {
        startTime = " 00:00:00";
        endTime = " 12:00:00";
      } else {
        startTime = " 12:00:00";
        endTime = " 23:59:00";
      }
      var param = new FormData();
      param.append("telephone", this.deviceTel);
      // param.append("curPage", 1);
      // param.append("pageSize", -1);
      param.append("start", date + startTime);
      param.append("end", date + endTime);

      that.$util.req_post(param, api.url_device_video_List, function (_r) {
        if (_r.data && _r.data.length != 0) {
          _r.data.forEach((e) => {
            e.isCheck = false;
          });
          that.playList = _r.data;
          that.loadReplay(item);
        }
      });
    },
    loadReplay(e) {
      var that = this;
      this.realPlayShow = false;
      this.fullscreenLoading = false;
      this.playList.forEach((element) => {
        element.isCheck = false;
      });
      e.isCheck = true;
      // this.loading = this.$loading({ fullscreen: true });
      setTimeout(function () {
        that.realPlayShow = true;
        that.replay(e);
      }, 300);
    },
    replay(e) {
      //播放
      // this.loading.close();
      let that = this;
      var param = new FormData();
      param.append("terminalPhone", e.terminalPhone);
      param.append("channel", e.channel);
      param.append("startTime", e.startTime);
      param.append("endTime", e.endTime);

      that.$util.req_post(param, api.url_video_replay, function (_r) {
        that.$nextTick(function () {
          // console.log(_r.data.videoURL)
          // that.options.source = _r.data.videoURL;
          that.$refs["videoPlay"].handelVideoUrl(_r.data.videoURL);
          that.onSelect(e);
        });
      });
    },
    mouseover(item, index) {
      //划过时的逻辑
      var that = this;
      this.$nextTick(function () {
        that.playList.forEach(function (item) {
          that.$set(item, "active", false);
        });
        item.active = true;
      });
    },
    onSelect(item, index) {
      //点击
      var that = this;
      this.$nextTick(function () {
        that.playList.forEach(function (item) {
          that.$set(item, "active", false);
        });
        item.active = true;
      });
    },

    mouseout(item) {
      //划出时的逻辑
      this.$set(item, "active", false);
    },
  },
};
</script>

<style scoped lang='scss'>
.line {
  @include line;
}
.input {
  width: 100%;
  overflow: hidden;
}
.aliplayer {
  height: 400px !important;
}
.video {
  width: 100%;
  height: 400px;
  display: flex;
  display: -webkit-flex; /* Safari */
  justify-content: space-between;
}

.videoLeft {
  width: 400px;
}
.videoLeft > h1 {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  background: #0064de;
  color: #fff;
  font-weight: normal;
}
.videoList {
  width: 100%;
  height: 360px;
  margin-top: 10px;
  overflow-y: auto;
}
.videoList li {
  cursor: pointer;
  width: 100%;
  display: flex;
  display: -webkit-flex; /* Safari */
  line-height: 18px;
  justify-content: space-around;
  border-bottom: 1px solid #e0e3ea;
  padding: 8px 0;
}

.videoList li i {
  font-size: 18px;
  color: #167fff;
  opacity: 0.3;
  height: 18px;
}

.videoList li p {
  font-size: 12px;
  color: #bbb;
  height: 18px;
}
.videoList .active i {
  opacity: 1;
}
.videoList .active p {
  color: #000;
}

.videoRight {
  width: 380px;
  height: 100%;
  margin-left: 5px;
}
</style>
<style lang='scss'>
.dialogForm {
  @include dialogForm;
}
</style>



// WEBPACK FOOTER //
// src/components/vueAliplayerV2/rePlay.vue